export default __webpack_public_path__ + "static/media/step-7.96666eeb.png";